// Central test id constants
export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  emailInput: "login-email-input",
  passwordInput: "login-password-input",
  submitBtn: "login-submit-btn",
  logoutBtn: "logout-btn",
  inviteAcceptBtn: "invite-accept-btn",
  invitePasswordInput: "invite-password-input",
  inviteConfirmInput: "invite-confirm-input",
};

export const NAV = {
  brand: "app-brand",
  dashboard: "nav-dashboard",
  createFile: "nav-create-file",
  myFiles: "nav-my-files",
  shared: "nav-shared",
  sent: "nav-sent",
  approved: "nav-approved",
  depository: "nav-depository",
  admin: "nav-admin",
  profileMenu: "profile-menu",
};

export const DASHBOARD = {
  createFileBtn: "create-file-btn",
  fileNameInput: "new-file-name-input",
  createSubmitBtn: "create-file-submit-btn",
  fileRow: (id) => `file-row-${id}`,
  openFileBtn: (id) => `open-file-${id}`,
  statCard: (key) => `stat-${key}`,
};

export const EDITOR = {
  content: "editor-content",
  saveBtn: "editor-save-btn",
  sendBtn: "editor-send-btn",
  sendBackBtn: "editor-send-back-btn",
  revokeBtn: "editor-revoke-btn",
  approveBtn: "editor-approve-btn",
  printBtn: "editor-print-btn",
  attachDocsBtn: "editor-attach-docs-btn",
  splitBtn: "editor-split-view-btn",
  historyBtn: "editor-history-btn",
  sendDialogUser: "send-dialog-user-select",
  sendDialogMessage: "send-dialog-message",
  sendDialogConfirm: "send-dialog-confirm",
  sendDialogQuickBack: "send-dialog-quick-back",
};

export const DEPOSITORY = {
  uploadBtn: "depository-upload-btn",
  uploadInput: "depository-upload-input",
  titleInput: "depository-title-input",
  submitBtn: "depository-submit-btn",
  docRow: (id) => `doc-row-${id}`,
  deleteBtn: (id) => `doc-delete-${id}`,
};

export const ADMIN = {
  inviteBtn: "admin-invite-btn",
  inviteEmail: "admin-invite-email",
  inviteName: "admin-invite-name",
  inviteDesignation: "admin-invite-designation",
  inviteRole: "admin-invite-role",
  inviteSubmit: "admin-invite-submit",
  inviteRow: (id) => `invite-row-${id}`,
};
